import { Fx, Icon, Input, Space, Text, Tooltip } from 'Components';
import {
	MESSAGE_BY_TEST_TYPE,
	RULE_TYPES
} from './NewPasswordFields.constants';
import { useNewPasswordFields } from './NewPasswordFields.hooks';
import { isString } from 'lodash';
import { useTranslation } from 'react-i18next';
import { getAdditionalInfoByRule } from './NewPasswordFields.helpers';
import styles from 'Pages/Auth/ResetPassword/ResetPassword.module.scss';

function NewPasswordFields() {
	const { t } = useTranslation();
	const { validByRule } = useNewPasswordFields();

	return (
		<>
			<Input.PasswordFormikField
				name="password"
				label={t('auth.changePassword.inputs.password')}
				help={null}
				placeholder="Enter new Password"
			/>

			<Input.PasswordFormikField
				name="confirmPassword"
				label={t('auth.changePassword.inputs.confirmPassword')}
				help={null}
				placeholder="Confirm Password"
			/>

			<div className={styles.validationQuide}>
				{RULE_TYPES.map((rule, index) => {
					const message = MESSAGE_BY_TEST_TYPE[rule];
					const messageDescription = isString(message)
						? t(message)
						: t(message.key, message.params);
					const valid = validByRule[rule];
					const info = getAdditionalInfoByRule(rule);

					return (
						<div key={index} style={{ marginBottom: 6 }}>
							<Space align="center">
								<Fx inline>
									<Text>
										<Icon
											type="check"
											className={`check-icon ${
												valid ? 'checked' : ''
											}`}
										/>
									</Text>
								</Fx>

								<Text
									className={`text-instruction ${
										valid ? 'text-success' : ''
									}`}
								>
									{messageDescription}
								</Text>

								{info && (
									<Text color="default">
										<Tooltip
											title={info}
											placement="topRight"
										>
											<Icon
												type="infoOutlined"
												size="md"
											/>
										</Tooltip>
									</Text>
								)}
							</Space>
						</div>
					);
				})}
			</div>
		</>
	);
}

export default NewPasswordFields;
